import useSQLite from '../useSQLite'
import { defineSqliteFeature } from './define-feature'

const { getItem, setItem, removeItem, listEntries } = useSQLite()

export const HTTP_CACHE_PREFIX = 'http-cache:'

export const makeHttpCacheKey = (key) => `${HTTP_CACHE_PREFIX}${key}`

export const stripHttpCachePrefix = (key) =>
    key && key.startsWith(HTTP_CACHE_PREFIX) ? key.slice(HTTP_CACHE_PREFIX.length) : key

export async function readHttpCache(key, defaultValue = null) {
    if (!key) return defaultValue
    return getItem(makeHttpCacheKey(key), defaultValue)
}

export async function writeHttpCache(key, data) {
    if (!key) return
    await setItem(makeHttpCacheKey(key), { data, updatedAt: Date.now() })
}

export async function removeHttpCache(key) {
    if (!key) return
    await removeItem(makeHttpCacheKey(key))
}

export async function listHttpCacheEntries() {
    return listEntries({ prefix: HTTP_CACHE_PREFIX })
}

const HTTP_TTL_SEC = 7 * 86400
const NOOP = async () => {}

export default defineSqliteFeature({
    key: 'http',
    purgeOnLogout: true,
    ensureSchema: NOOP,
    onBoot: ({ pruneKeys }) => pruneKeys({ prefix: HTTP_CACHE_PREFIX, maxAgeSec: HTTP_TTL_SEC }),
    getSummary: ({ getKeyStats }) => getKeyStats({ prefix: HTTP_CACHE_PREFIX }),
    purge: ({ pruneKeys }) => pruneKeys({ prefix: HTTP_CACHE_PREFIX }),
    fallbacks: {
        onBoot: { ok: false, cleared: 0 },
        getSummary: null,
        purge: { ok: false, cleared: 0 },
    },
})
